import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContextSystem } from '@wp-g2/context';
export function useBaseChoice(props, namespace) {
  if (namespace === void 0) {
    namespace = 'BaseChoice';
  }

  var _useContextSystem = useContextSystem(props, namespace),
      gap = _useContextSystem.gap,
      help = _useContextSystem.help,
      label = _useContextSystem.label,
      labelHidden = _useContextSystem.labelHidden,
      _useContextSystem$spa = _useContextSystem.spacing,
      spacing = _useContextSystem$spa === void 0 ? 1 : _useContextSystem$spa,
      _useContextSystem$tem = _useContextSystem.templateColumns,
      templateColumns = _useContextSystem$tem === void 0 ? 'auto 1fr' : _useContextSystem$tem,
      _useContextSystem$tru = _useContextSystem.truncate,
      truncate = _useContextSystem$tru === void 0 ? true : _useContextSystem$tru,
      otherProps = _objectWithoutProperties(_useContextSystem, ["gap", "help", "label", "labelHidden", "spacing", "templateColumns", "truncate"]);

  return _objectSpread(_objectSpread({}, otherProps), {}, {
    baseChoice: {
      gap: gap,
      help: help,
      label: label,
      labelHidden: labelHidden,
      templateColumns: templateColumns,
      spacing: spacing,
      truncate: truncate
    }
  });
}